import React, { useRef, useState } from "react";
import ConfirmModal from "../../components/confirmModal/confirmModel";
import FileUpload from "../../components/fileUpload/fileUpload";
import { useTranslation } from "react-i18next";


/**
 * Component for importing users.
 * @param {Object} props - The component props.
 * @param {Function} props.showImportUserModal - Function to show the import user modal.
 * @param {Function} props.closeImportUserModal - Function to close the import user modal.
 * @param {Array} props.uploadedUserFile - Array of uploaded user files.
 * @param {Function} props.handleUserFileUpload - Function to handle user file upload.
 * @param {Function} props.handleClearUploadedUserFile - Function to clear uploaded user file.
 * @param {Function} props.ImportFileSubmit - Function to submit the imported file.
 * @param {boolean} props.loaderButtonShow - Flag to show the loader
 */
const ImportUsers = (props) => {
  const { t } = useTranslation();
  const {
    showImportUserModal,
    closeImportUserModal,
    uploadedUserFile,
    handleUserFileUpload,
    handleClearUploadedUserFile,
    ImportFileSubmit,
    loaderButtonShow,
    downLoadButton
  } = props;

  // loader state
  const [isUploading, setisUploading] = useState(false);

  // trigger dropzone open
  let triggerRef = useRef(null);

  // file upload
  /**
   * Handles the upload of files by calling the provided upload function and updating the loader state.
   * @param {FileList} files - The list of files to upload.
   * @param {function} loaderState - The function to update the loader state.
   * @param {function} uploadFunction - The function to handle the file upload.
   * @returns None
   */
  const handleFileUpload = (files, loaderState, uploadFunction) => {
    loaderState(true);
    uploadFunction(files);

    setTimeout(() => {
      loaderState(false);
    }, 3000);
  };

  const accept = {
    "text/csv": [],
  };

  return (
    <ConfirmModal
      className={"Deactivate import-model"}
      modalTitle={t("IMPORT_USERS")}
      isUnderline={false}
      showModal={showImportUserModal}
      onHide={() => closeImportUserModal()}
      isModelIcon={false}
      modalContent={false}
      isFirstButton={true}
      isSecondButton={true}
      leftBtnTitle={t("IMPORT")}
      leftBtnIcon={<i className="bx bx-import" />}
      rightBtnIcon={<i className="mdi mdi-download" />}
      leftBtnClass={"ok_Btn"}
      rightBtnClass="Cancel_Btn"
      rightBtnTitle={t("DOWNLOAD_SAMPLE")}
      onProcced={ImportFileSubmit}
      closeModelIcon={() => closeImportUserModal()}
      leftdisabled={!uploadedUserFile}
      isCloseBtn={true}
      loaderButtonShow={loaderButtonShow}
      rightButtonClick={downLoadButton}
      rightdisabled={false}
    >
      <div className="uploadWrapper">
        <p className="Title">{t("UPLOAD")}</p>
        {uploadedUserFile ? (
          <>
            <div className="imagePlaceholder">
              <div className="imagePlaceholderWrapper">
                <div className="ImageUploader">
                  <i className="mdi mdi-file-outline" />
                  <p>{uploadedUserFile.map((i) => i.name)}</p>
                </div>
                <span
                  className="clearimage"
                  onClick={handleClearUploadedUserFile}
                >
                  <i className="bx bxs-minus-circle" />
                </span>
              </div>
            </div>
          </>
        ) : (
          <FileUpload
            onDrop={(acceptedFiles) => {
              const csvFiles = acceptedFiles.filter(
                (file) => file.type === "text/csv" || file.name.endsWith(".csv")
              );
              if (csvFiles?.length > 0) {
                handleFileUpload(
                  csvFiles,
                  setisUploading,
                  handleUserFileUpload
                );
              }
            }}
            maxSize={10 * 1024 * 1024}
            accept={accept}
            triggerOpen={triggerRef}
          >
            <>
              {isUploading ? (
                <>
                  <div className="progress-wrapper">
                    <div className="progress">
                      <div className="progress-value"></div>
                    </div>
                    <p>{t("UPLOADING")}</p>
                  </div>
                </>
              ) : (
                <div className="fropZoneWrapper">
                  <i className="mdi mdi-cloud-upload-outline" />
                  <p>
                    {t("DRAG_AND_DROP_HERE_OR")} <b>{t("BROWSE")}</b> <br />{" "}
                    {t("MAX_SIZE_10_MB")}
                  </p>
                </div>
              )}
            </>
          </FileUpload>
        )}
      </div>
    </ConfirmModal>
  );
};

export default ImportUsers;
